import React, {Component} from "react";
import {Col, ControlLabel, FormGroup, Grid, Row, FormControl} from "react-bootstrap";
import ImageUpload from "../../components/ImageUpload/ImageUpload";
import Button from "../../components/CustomButton/CustomButton";
import {userActions} from "../../authentication/_actions";
import axios from "axios";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import Card from "../../components/Card/Card";
import qrCodeImage from "../../assets/img/qr-code.png";
import eas_logo from "../../assets/img/eas_svg.png";

class QrCodeManagement extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fire_tv_url: null,
            mobile_ios_url: null,
            mobile_android_url: null,
            information_portal_android_url: null,
            information_portal_ios_url: null,

            fire_tv_url_qr: null,
            mobile_ios_url_qr: null,
            mobile_android_url_qr: null,
            information_portal_android_url_qr: null,
            information_portal_ios_url_qr: null,

            mobile_redirect: null,
            information_portal_redirect: null,

            loading: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);

    }

    componentDidMount() {
        this.getDataFromMiddleware();
    }

    getDataFromMiddleware() {


        this.setState({loading: true});

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };

        const url = process.env.REACT_APP_API_URL + "/Global/GetQrCodes";

        axios
            .get(url, axiosConfig)
            .then(res => {

                let qrCodeData = res.data;
                this.setState({
                    fire_tv_url: qrCodeData[0].fire_tv_url,
                    mobile_ios_url: qrCodeData[1].mobile_ios_url,
                    mobile_android_url: qrCodeData[2].mobile_android_url,
                    information_portal_android_url: qrCodeData[3].information_portal_android_url,
                    information_portal_ios_url: qrCodeData[4].information_portal_ios_url,

                    fire_tv_url_qr: qrCodeData[0].fire_tv_url_qr,
                    mobile_ios_url_qr: qrCodeData[1].mobile_ios_url_qr,
                    mobile_android_url_qr: qrCodeData[2].mobile_android_url_qr,
                    information_portal_android_url_qr: qrCodeData[3].information_portal_android_url_qr,
                    information_portal_ios_url_qr: qrCodeData[4].information_portal_ios_url_qr,

                    mobile_redirect: qrCodeData[2].mobile_android_url_redirect,
                    information_portal_redirect: qrCodeData[3].information_portal_android_url_redirect,

                    loading: false
                })
            }).catch(error => {
            console.log(error);
            this.setState({loading: false})
        });

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    submitChanges() {

    }

    render() {
        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <Grid fluid>
                                        <Row>
                                            <Col sm={12}>
                                                <div className="center">
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '50px', maxWidth: '100%'}}
                                                         src={qrCodeImage}
                                                         alt={"qrCodeImage"}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Card
                                title={<legend>Device Assets</legend>}
                                content={
                                    <Grid fluid>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Fire TV Application</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.fire_tv_url_qr}
                                                         alt={"fire_tv_url_qr"}
                                                    />
                                                    <FormControl placeholder="Confirm password"
                                                                 type="text"
                                                                 disabled={this.state.loading}
                                                                 name="fire_tv_url"
                                                                 onChange={this.handleInputChange}
                                                                 value={this.state.fire_tv_url || ''}
                                                    />
                                                </FormGroup>

                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Mobile iOS QR Code</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.mobile_ios_url_qr}
                                                         alt={"mobile_ios_url_qr"}
                                                    />
                                                    <FormControl placeholder="Enter ios url"
                                                                 type="text"
                                                                 disabled={this.state.loading}
                                                                 name="mobile_tv_url"
                                                                 onChange={this.handleInputChange}
                                                                 value={this.state.mobile_ios_url || ''}
                                                    />


                                                </FormGroup>
                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Mobile Android QR Code</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.mobile_android_url_qr}
                                                         alt={"mobile_android_url_qr"}
                                                    />
                                                    <FormControl placeholder="Enter android url"
                                                                 type="text"
                                                                 disabled={this.state.loading}
                                                                 name="mobile_tv_url"
                                                                 onChange={this.handleInputChange}
                                                                 value={this.state.mobile_android_url || ''}
                                                    />

                                                </FormGroup>

                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Mobile QR Code for Customers</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.mobile_redirect}
                                                         alt={"mobile_redirect"}
                                                    />
                                                </FormGroup>

                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>iOS Information Portal QR Code</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.information_portal_ios_url_qr}
                                                         alt={"information_portal_ios_url_qr"}
                                                    />
                                                    <FormControl placeholder="Enter information portal ios url"
                                                                 type="text"
                                                                 disabled={this.state.loading}
                                                                 name="information_portal_ios_url"
                                                                 onChange={this.handleInputChange}
                                                                 value={this.state.information_portal_ios_url || ''}
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Android Information Portal QR Code</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.information_portal_android_url_qr}
                                                         alt={"information_portal_android_url_qr"}
                                                    />
                                                    <FormControl placeholder="Enter information portal android url"
                                                                 type="text"
                                                                 disabled={this.state.loading}
                                                                 name="information_portal_android_url"
                                                                 onChange={this.handleInputChange}
                                                                 value={this.state.information_portal_android_url || ''}
                                                    />
                                                </FormGroup>

                                                <FormGroup>
                                                    <div className="center text-center center-block">
                                                        <ControlLabel>Information Portal QR Code for Customers</ControlLabel>
                                                    </div>
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '150px', maxWidth: '90%'}}
                                                         src={this.state.mobile_redirect}
                                                         alt={"mobile_redirect"}
                                                    />
                                                </FormGroup>

                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <div className="pull-right" style={{marginTop: "15px"}}>
                                                    <FormGroup>
                                                        <Button
                                                            fill
                                                            bsStyle="primary"
                                                            onClick={this.submitChanges.bind(this)}
                                                        >
                                                            Apply changes
                                                        </Button>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>


                </Grid>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedQrCodeManagement = connect(mapStateToProps)(QrCodeManagement);
const connectedQrCodeManagementTrans = withNamespaces('common')(connectedQrCodeManagement);
export {connectedQrCodeManagementTrans as QrCodeManagement};
